import { InputLabel, Select, SelectChangeEvent, styled } from "@mui/material";
import dropdownArrowIcon from "../../components/icons/dropdownArrowIcon.svg";
import classes from "./customSelect.module.css";

interface IProps {
  label?: string;
  value: string | number;
  onChange: (event: SelectChangeEvent) => void;
  children: React.ReactNode;
  border?: boolean;
}

const CustomSelect = (props: IProps) => {
  const {
    label,
    value,
    onChange,
    children,
    border = true
  } = props;

  return (
    <div style={{ cursor: "pointer" }}>
      <InputLabel>{label}</InputLabel>
      <Select
        className={classes.select + (!border ? classes.borderless : "")}
        variant="outlined"
        value={value.toString()}
        onChange={onChange}
        IconComponent={() => (
          <StyledIcon src={dropdownArrowIcon} alt="arrow_icon" />
        )}
        inputProps={{
          classes: {
            icon: classes.icon,
            root: classes.root
          }
        }}
        MenuProps={{
          classes: {
            list: classes.list
          }
        }}
        sx={{
          borderRadius: "8px",
          "& .MuiSelect-select": {
            textOverflow: "unset !important"
          }
        }}
      >
        {children}
      </Select>
    </div>
  );
};

const StyledIcon = styled("img")({
  height: "5px",
  marginRight: "12px",
  "&:hover": {
    cursor: "pointer",
  }
});

export default CustomSelect;

